// extracted by mini-css-extract-plugin
export default {"CopyrightText":"PageFooter_CopyrightText__NOqUa"};